import { DatePicker } from "@ui";
import style from "./IncomeControlPanel.module.scss";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setActiveEndDate, setActiveStartDate } from "@global-state/pages/admin/dashboard/slice";
import { authApi } from "@RTKQuery/basic";

export function IncomeControlPanel() {
    const dispatch = useAppDispatch();
    
    const { activeStartDate, activeEndDate } = useAppSelector(state => state.dashboardAdminPage);

    return (
        <div className={style.conteiner}>
            <p className={style.label}>Cтатистика по операторам</p>
            <button type="button" className={style.refreshButton} onClick={() => dispatch(
                authApi.util.invalidateTags([
                    {type: "PurchaseHistoryAdmin", id: "ANALYTICS"}, "CostsAdmin", "ProxyAdmin"
                ])
            )}>Оновити статистику</button>
            <DatePicker
                currentDate={
                    {
                        start: activeStartDate ? activeStartDate.split("-").reverse().join(".") : "Початкова дата",
                        end: activeEndDate ? activeEndDate.split("-").reverse().join(".") : "Кінцева дата"
                    }
                }
                onChangeDate={(newDate, type) => {
                    const formatDate = newDate.split(".").reverse().join("-");

                    if (type === "start") {
                        dispatch(setActiveStartDate(newDate !== "Початкова дата" ? formatDate : ""))
                    }
                    if (type === "end") {
                        dispatch(setActiveEndDate(newDate !== "Кінцева дата" ? formatDate : ""))
                    }
                }}
            />
        </div>
    )
}
